import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["viewBox"];
import React from 'react';

var Discount = function Discount(_ref) {
  var _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 100 100' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: viewBox
  }, unhandledProps), /*#__PURE__*/React.createElement("path", {
    d: "M35,38c0-1.655,1.345-3,3-3s3,1.345,3,3s-1.345,3-3,3S35,39.655,35,38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,62c0,1.655-1.345,3-3,3s-3-1.345-3-3s1.345-3,3-3S65,60.345,65,62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.231,43.197l-5.168-5.32C83.378,37.171,83,36.239,83,35.255v-8.49C83,21.38,78.62,17,73.235,17h-8.49  c-0.984,0-1.916-0.378-2.625-1.066l-5.317-5.165c-3.814-3.703-9.791-3.703-13.605,0l-5.32,5.168C37.171,16.622,36.239,17,35.255,17  h-8.49C21.38,17,17,21.38,17,26.765v8.49c0,0.984-0.378,1.916-1.066,2.625l-5.165,5.317c-3.703,3.814-3.703,9.791,0,13.605  l5.168,5.32C16.622,62.829,17,63.761,17,64.745v8.49C17,78.62,21.38,83,26.765,83h8.49c0.984,0,1.916,0.378,2.625,1.066l5.317,5.165  c1.907,1.852,4.354,2.777,6.803,2.777s4.896-0.926,6.803-2.777l5.32-5.168C62.829,83.378,63.761,83,64.745,83h8.49  C78.62,83,83,78.62,83,73.235v-8.49c0-0.984,0.378-1.916,1.066-2.625l5.165-5.317C92.935,52.988,92.935,47.012,89.231,43.197z   M38,29c4.963,0,9,4.037,9,9s-4.037,9-9,9s-9-4.037-9-9S33.037,29,38,29z M62,71c-4.963,0-9-4.037-9-9s4.037-9,9-9s9,4.037,9,9  S66.963,71,62,71z M70.121,34.121l-36,36c-1.172,1.172-3.07,1.172-4.242,0c-1.172-1.172-1.172-3.07,0-4.242l36-36  c1.172-1.172,3.07-1.172,4.242,0S71.293,32.949,70.121,34.121z"
  }));
};

Discount.displayName = 'Discount';
export default Discount;